import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// Imported
import { Toaster } from "react-hot-toast";

// Components
import App from "./App";

// CSS
import "./CSS/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
    <Toaster
      position="top-center"
      toastOptions={{
        style: {
          zIndex: 9999,
          fontFamily: "Quicksand",
          fontWeight: "600",
        },
      }}
    />
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
